export const isValueANumber = (val: any): val is number => {
  const parsedVal = parseInt(val, 10);
  return !Number.isNaN(parsedVal);
};
